const E = {
  Supply: "Supply",
  Back: 'Back',
  'Project Number': 'Project Number',
  Jobs: 'Jobs',
  Cancel: 'Cancel',
  Ok: 'Ok',
  'eCOC Templates': 'eCOC Templates',
  Invoices: 'Invoices',
  Supplies: 'Supplies',
  Columns: 'Columns',
  'view more': 'view more',
  Templates: 'Templates',
  'Custom Reports': 'Custom Reports',
  Login: 'Login',
  Resources: 'Resources',
  'My Account': 'My Account',
  Overview: 'Overview',
  Close: 'Close',
  English: 'English',
  French: 'French',
  'Export to Excel': 'Export to Excel',
  'Clear Search': 'Clear Search',
  'Upload Excel': 'Upload Excel',
  'Results per page': 'Results per page',
  SaveAndClose: 'Save & Close',
  SaveAndNext: 'Save & Next',
  Add: 'Add',
  Remove: 'Remove',
  SelectAll: 'Select All',
  Clients: 'Clients',
  'Date & Format': 'Date & Format',
  Samples: 'Samples',
  Parameters: 'Parameters',
  'Criteria & Create': 'Criteria & Create',
  Details: 'Details',
  Tests: 'Tests',
  Shipping: 'Shipping',
  Summary: 'Summary',
  Labels: 'Labels',
  SameAsInvoice: 'SAME AS INVOICE',
  Delete: 'Delete',
  delete: 'delete',
  MultiDelete: 'Multi Delete',
  Copy: 'Copy',
  copy: 'copy',
  edit: 'edit',
  Edit: 'Edit',
  Disjoin: 'Disjoin',
  'New Job': 'New Job',
  'based on this': 'based on this',
  'Zip and Download All': 'Zip and Download All',
  View: 'View',

  'new job': 'new job',
  templates: 'templates',
  'order supplies': 'order supplies',
  share: 'share',
  'export to excel': 'export to excel',
  view: 'view',
  'pay invoice': 'pay invoice',
  'receipt':'Receipt',
  Submit: 'Submit',
  'Download PDF': 'Download PDF',
  pleaseEnterDate: 'Please enter date',
  'Please Select an Option': 'Please Select an Option',
  PageUnavailable: 'There’s been an unexpected error.',
  PageUnavailableDescription:
    'We apologize for the inconvenience. Please refresh the page and try again, or contact your Bureau Veritas representative for assistance.',
  TokenInvalidMessage:
    'Your identity token is no longer valid. For security reasons, you will be redirected to the login page.',
  Job: 'Job',
  NotFound: 'Not Found',
  NoClient: 'To begin, please select a Client',
  readyToSubmit: 'I’m ready to submit',
  refresh: 'Refresh',
  Allow: 'Allow',
  Deny: 'Deny',
  download: 'download',
  Template: 'Template',
  Submission: 'Submission',
  Order: 'Order',
  Share: 'Share',
  All: 'All',
  cancel: 'cancel',
  'new template': 'new template',
  Proceed: 'Proceed',
  ok: 'OK',
  sessionTimeOut: 'Session has expired, Please log in again.',
  'Delete the': 'Delete the',
  '12 Hour': '12 Hour',
  '24 Hour': '24 Hour',
  'Back to Job Details': 'Back to Job Details',
  Next: 'Next',
  Yes: 'Yes',
  No: 'No',
  Num: 'No.',
  email: 'Email',
  'Eastern Region': 'Eastern Region',
  'Western Region': 'Western Region',
  'Quebec Region': 'Quebec Region',
  of: 'of',
  eCOC: 'eCOC',
  'Not Specified': 'Not Specified',
  None: 'None',
  Custom: 'Custom',
  offlineConnection:
    'Oops! You are offline right now.  Check your internet connection.',
  Search: 'Search',
  Save: 'Save',
  Verified: 'Verified',
  New: 'New',
  'Service Level': 'Service Level',
  'AdditionalAnalysis': 'Additional Analysis',
  Filter: 'Filter',
  Matrix: 'Matrix',
  'Additional Supplies': 'Additional Supplies',
  PaymentSummary: 'Payment Summary',
  Payment: 'Payment',
  'Additional Supplies': 'Additional Supplies',
  SplitReportId: "Report #",
};

const F = {
  Supply: "Fournir",
  Filter: 'Filtrer',
  'AdditionalAnalysis': 'Analyse supplémentaire',
  'Additional Supplies': 'Matériaux supplémentaires',
  'Service Level': 'Délai requis',
  Save: 'Enregistrer',
  Search: 'Chercher',
  None: 'Aucun',
  'Not Specified': 'Non précisé',
  of: 'de',
  'Eastern Region': 'Région est',
  'Western Region': 'Région ouest',
  'Quebec Region': 'Région du Québec',
  email: 'Courriel',
  Yes: 'Oui',
  No: 'Non',
  Num: 'No.',
  sessionTimeOut: 'La session a expiré, Veuillez vous reconnecter.',
  'Please Select an Option': 'Veuillez sélectionner une option',
  ok: "D'accord",
  'new template': 'Créer nouveau formulaire',
  cancel: 'Annuler',
  Back: 'Retour',
  refresh: 'Actualiser',
  Deny: 'Refuser',
  Allow: 'Autoriser',
  'Project Number': 'Numéro de projet',
  Jobs: 'Dossiers',
  'eCOC Templates': 'Modèles d’eCDR',
  eCOC: 'eCDR',
  Invoices: 'Factures',
  Supplies: 'Matériel',
  Columns: 'Colonnes',
  'view more': 'Afficher plus',
  Templates: 'Modèles',
  'Custom Reports': 'Rapports personnalisés',
  Login: 'Connexion',
  Resources: 'Ressources',
  'My Account': 'Mon compte',
  Custom: 'Personnalisé',
  Overview: 'Aperçu',
  Close: 'Fermer',
  English: 'Anglais',
  French: 'Français',
  'Export to Excel': 'Exporter en Excel',
  'Clear Search': 'Effacer la recherche',
  'Upload Excel': 'Télécharger vers Excel',
  'Results per page': 'Résultats par page',
  SaveAndClose: 'Enregistrer et fermer',
  SaveAndNext: 'Enregistrer et suivant',
  Add: 'Ajouter',
  Remove: 'Supprimer',
  SelectAll: 'Sélectionner tout',
  Clients: 'Clients',
  'Date & Format': 'Format de la date',
  Samples: 'Échantillons',
  Parameters: 'Paramètres',
  'Criteria & Create': 'Critères et créer',
  Details: 'Détails',
  Tests: 'Analyses',
  Shipping: 'Envoi',
  Summary: 'Résumé',
  Labels: 'Étiquettes',
  SameAsInvoice: 'MÊME QUE FACTURATION',
  Delete: 'Supprimer',
  Copy: 'Copier',
  Disjoin: 'Séparer',
  'New Job': 'Nouveau dossier',
  'based on this': 'basé sur',
  'Zip and Download All': 'Compresser et télécharger tout',
  View: 'Afficher',
  download: 'télécharger',
  Verified: 'Vérifié',
  New: 'Nouveau',
  delete: 'supprimer',
  MultiDelete: 'Supprimer multiple',
  edit: 'modifier',
  Edit: 'Modifier',
  copy: 'copier',
  'new job': 'nouveau dossier',
  templates: 'modèles',
  'order supplies': 'commander du matériel',
  share: 'partager',
  'export to excel': 'exporter vers Excel',
  view: 'afficher',
  'pay invoice': 'payer facture',
  'receipt': 'Reçu',
  Submit: 'Soumettre',
  'Download PDF': 'Télécharger le PDF',
  pleaseEnterDate: 'Veuillez inscrire la date',
  PageUnavailable: 'Il y a eu une erreur inattendue.',
  PageUnavailableDescription:
    'Nous nous excusons pour ce contretemps. Veuillez actualiser la page et réessayer, ou contactez votre représentant ou représentante Bureau Veritas pour obtenir de l’aide.',
  TokenInvalidMessage:
    "Votre identification n’est plus valide car votre adresse IP a été changée par votre compagnie. Pour des raisons de sécurité, vous allez être redirigé vers la page de connexion. Pour toute information supplémentaire, veuillez contacter votre chargé de projet Bureau Veritas.",
  Job: 'Dossier',
  NotFound: 'Introuvable',
  NoClient: 'Pour commencer, veuillez choisir un client',
  readyToSubmit: 'Prêt à envoyer',
  Template: 'Modèle',
  Submission: 'Envoi',
  Order: 'Commande',
  Share: 'Partager',
  All: 'Tous',
  Proceed: 'Procéder',
  Cancel: 'Annuler',
  Ok: "d'accord",
  'Delete the': 'Supprimer le',
  '12 Hour': '12 heures',
  '24 Hour': '24 heures',
  'Back to Job Details': 'Retour aux détails du travail',
  Next: 'Suivante',
  offlineConnection:
    'Oups! Vous êtes en mode hors connexion. Vérifiez votre connexion Internet.',
  Matrix: 'Matrice',
  PaymentSummary: 'Résumé de paiement',
  Payment: 'paiement',
  SplitReportId: "Report #",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/common.js